export const TextEffectsShookViewerType = 'wixui.TextEffectsShook' as const;

export const TestIds = {
  viewer: {
    container: 'text-effects-shook-container',
    layer: 'text-effects-shook-layer',
    text: 'text-effects-shook-text',
  },
} as const;
export const dataHooks = {
  design: {
    borderColorSelect: 'text-effects-shook-border-color-select',
    borderWidthSlider: 'text-effects-shook-border-width-slider',
    bevelAngleInput: 'text-effects-shook-bevel-angle-input',
    layerSpacingInput: 'text-effects-shook-layer-spacing-input',
  },
};
